import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Price from "../../../components/Price.vue";
import TextContentLoading from "./TextContentLoading.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoadingPrice',
    props: {
        amount: Number,
        width: String,
        height: String,
        loading: Boolean,
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(TextContentLoading, {
                width: __props.width,
                height: __props.height,
                loading: __props.loading
            }, {
                default: _withCtx(() => [
                    _createVNode(Price, {
                        amount: __props.amount,
                        long: "",
                        "fixed-width": ""
                    }, null, 8 /* PROPS */, ["amount"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["width", "height", "loading"]));
        };
    }
});
